import FingoMuiOutlinedInput, { formOutlinedInput } from '../../fingo/components/MuiOutlinedInput';
import {
  DEFAULT_OUTLINED_INPUT_CLASS_NAME,
  FORM_OUTLINED_INPUT_CLASS_NAME,
} from '../../constants/outlined-input';

const defaultOutlinedInput = ({ theme }) => ({
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.secondary.A400,
    },
  },
});

const MuiOutlinedInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiOutlinedInput.styleOverrides.root({ theme }),
      [`&.${DEFAULT_OUTLINED_INPUT_CLASS_NAME}`]: defaultOutlinedInput({ theme }),
      [`&.${FORM_OUTLINED_INPUT_CLASS_NAME}`]: formOutlinedInput({ theme, isSelectedBorderColor: theme.palette.secondary.A400 }),
    }),
    input: ({ theme }) => ({
      ...FingoMuiOutlinedInput.styleOverrides.input({ theme }),
    }),
  },
};

export default MuiOutlinedInput;
